

import React from 'react';
import './OurPricing.css';
import { Link } from 'react-router-dom';

function OurPricing() {
  return (
    <div className="OurPricingCover">
      <div className="PriceForeword">
        <h2>Let’s find the right plan for your business.</h2>
      </div>
      <div className="PriceParagraph">
        <p>Choose from a variety of plans and add-ons. You won’t pay a cent until you’re ready to run payroll.</p>
      </div>
      <div className="PlansCover">
        <div className="PlanCard">
          <div className="PlanHeader">
            <h3>Simple</h3>
            <p className="Price"><b>10 ZMW</b>/mo per person</p>
            <p className="PlanDescription">Best for new businesses and startups paying people in one province</p>
          </div>
          <ul className="PlanFeatures">
            <li>Full-service payroll</li>
            <li>Employee self-service</li>
            <li>Basic reports</li>
          </ul>
          <div className="PlanCTA">
          <button><Link style={{color: "white", textDecoration : "none"}} className='link' to="/login">Get Started</Link></button>
          </div>
        </div>
        {/* Repeat PlanCard for 'Plus' and 'Premium' plans */}
        <div className="PlanCard">
          <div className="PlanHeader">
            <h3>Plus</h3>
            <p className="Price"><b>20 ZMW</b>/mo per person</p>
            <p className="PlanDescription">Ideal for growing businesses needing more advanced features</p>
          </div>
          <ul className="PlanFeatures">
            <li>Everything in Simple</li>
            <li>Advanced reporting</li>
            <li>Time tracking</li>
          </ul>
          <div className="PlanCTA">
             <button><Link style={{color: "white", textDecoration : "none"}} className='link' to="/login">Get Started</Link></button>
          </div>
        </div>
        <div className="PlanCard">
          <div className="PlanHeader">
            <h3>Premium</h3>
            <p className="Price"><b>40 ZMW</b>/mo per person</p>
            <p className="PlanDescription">Best for businesses requiring comprehensive HR solutions</p>
          </div>
          <ul className="PlanFeatures">
            <li>Everything in Plus</li>
            <li>Performance management</li>
            <li>Dedicated support</li>
          </ul>
          <div className="PlanCTA">
            <button><Link style={{color: "white", textDecoration : "none"}} className='link' to="/login">Get Started</Link></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurPricing;




// import "./OurPricing.css"

// function OurPricing(){  
//     return <>

//           <div className="OurPricingCover">

//                          <div className="PriceForeword">

//                                 <h2>Let’s find the right plan for your business.</h2>
//                         </div>              

//                          <div className="PriceParagraph">
//                             <p>Choose from a variety of plans and add-ons. You won’t pay a cent until you’re ready to run payroll.</p>
//                         </div>              
//                          <div className="PlansCover">

//                             <div className="PlanSecCover">

//                                     <div className="PlanCard">
//                                         <div className="PriceDuration">
//                                                  <p><b>$40/mo per person</b></p>
//                                         </div>
//                                         <div className="PriceTagline">
//                                                 <h3>Simple</h3>
//                                         </div>
//                                         <div className="PriceTagParagraph">

//                                                 <p>Best for new bunsinesses and startups paying people in one province</p>

//                                         </div>

//                                     </div>
//                                     <div className="PlanCard">
//                                         <div className="PriceDuration">
//                                                 <p><b>$40/mo per person</b></p>
//                                         </div>
//                                         <div className="PriceTagline">
//                                                 <h3>Plus</h3>
//                                         </div>
//                                         <div className="PriceTagParagraph">

//                                                 <p>Best for new bunsinesses and startups paying people in one province</p>

//                                         </div>

//                                     </div>
//                                     <div className="PlanCard">
//                                         <div className="PriceDuration">
//                                               <p><b>$40/mo per person</b></p>
//                                         </div>
//                                         <div className="PriceTagline">
//                                                 <h3>Premium</h3>
//                                         </div>
//                                         <div className="PriceTagParagraph">

//                                                 <p>Best for new bunsinesses and startups paying people in one province</p>

//                                         </div>

//                                     </div>

//                             </div>
//                         </div>              
                  

     
//          </div>
        
//     </>

// }

// export default OurPricing;